/* eslint-disable */
// VENDORED from learning_brain_poc/diagmap.js (W7b / F3, POC commit 6ad5075e). Change: DiagMap.relayout() for the popover resize observer.
// Diagnosis map renderer for chat v4 (review 2026-10-11, R3-R10). Pure DOM + one SVG connector layer, no library.
// window.DiagMap = {render(host, data, options), destroy(host)}; the caller (rhs4.js) fetches POST /api/diagmap.
// Needs window.DiagMapLayout (diagmap_layout.js, loaded first). Every data string goes in as a text node.
(function () {
  'use strict';

  const TEXT = {
    override: 'Investigate this cause', overrideTip: 'Continue on this cause even if it was ruled out. Your earlier answers stay.',
    title: 'Diagnosis map',
    mapLabel: 'Diagnosis map. Arrow keys move, Enter selects, Escape clears.',
    legendLabel: 'Legend',
    legend: [
      {tone: 'now', glyph: '▶', text: 'Now and the way to it'},
      {tone: 'red', glyph: '✗', text: 'Ruled out'},
      {tone: 'answered', glyph: '●', text: 'Answered'},
      {tone: 'open', glyph: '○', text: 'Open'},
      {tone: 'muted', glyph: '┄', text: 'Not reached'},
    ],
    columns: {0: 'Problem', 1: 'Questions', 2: 'Follow-up questions', 3: 'Follow-up questions', 4: 'Possible causes', 5: 'Checks',
      6: 'Root cause and fix'},
    followUp: 'Follow-up',
    otherChecks: 'Other checks',
    toggleShow: n => 'Show unreached (' + n + ')',
    toggleHide: 'Hide unreached',
    liveShown: n => n + ' unreached answers and questions shown',
    liveHidden: n => n + ' unreached answers and questions hidden',
    colUnreached: n => '+' + n + ' unreached',
    more: n => 'Show ' + n + ' more',
    fewer: 'Show fewer',
    overflow: n => 'and ' + n + ' more ruled out',
    capped: n => 'Map shortened: ' + n + ' answers not drawn (too many)',
    empty: 'Describe the problem in the chat to see what was said and the possible causes it points to.',
    list: 'Map as a list',
    nowTag: 'Now',
    ruledTag: 'Ruled out',
    ruledEarlier: 'Ruled out earlier in this chat',
    rootCause: 'Root cause: ',
    fix: {mitigation: 'Fix: ', escalation: 'Escalation: '},
    fixDefault: 'Fix: ',
    readFromMessage: 'read from the message',
    confidence: p => 'Confidence ' + p + ' %',
    documented: 'Listed in the documented checks for this cause',
    seenWon: (n, w) => 'Seen in ' + n + ' past conversations, this was the cause in ' + w,
    seenNever: n => 'Seen in ' + n + ' past conversations, never the cause',
    follows: 'Follows the answer: ',
    ruledBy: 'Ruled out because: ',
    type: {symptom: 'Problem', question: 'Question', fact: 'Answer', cause: 'Possible cause', step: 'Check', root_cause: 'Root cause'},
    state: {leading: 'current', current_step: 'checking now', asking_now: 'asked now', on_path: 'on the way to the current cause',
      observed: 'answered', asked_not_chosen: 'asked, not chosen', open: 'open', ruled_out: 'ruled out', not_traversed: 'not reached'},
    step: {done: 'Confirmed', failed: 'Not confirmed', current: 'Checking now', pending: 'Not checked yet'},
    listProblem: 'Problem: ',
    listReached: 'Reached by: ',
    listNoAnswers: 'No answers point here yet.',
    listChecks: 'Checks: ',
    listAskedNow: 'Asked now: ',
    listOther: 'Other answers: ',
  };

  const GLYPH = {now: '▶', trail: '●', red: '✗', answered: '●', open: '○', muted: ''};
  const STORE_KEY = 'diagmap.showUnreached';
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const CURVE_MIN_PX = 16;
  const CURVE_RATIO = 0.5;
  const TIP_GAP_PX = 6;
  const HIT_WIDTH = 10;
  const EDGE_CLASS = {supports: 'dm-e-supports', weak_supports: 'dm-e-weak', refines: 'dm-e-refines', rules_out: 'dm-e-rules-out',
    tests: 'dm-e-answer', identifies: 'dm-e-answer'};
  const EDGE_LAYER = {muted: 0, open: 1, answered: 1, now: 2, trail: 2, red: 3};

  const hosts = new WeakMap();
  const liveHosts = new Set();      // V5 (W7b): iterable twin of `hosts` for relayout()
  const cleaned = new WeakMap();
  let observer = null, uid = 0, words = null;

  // ---------- helpers ----------
  function el(tag, cls, text) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = String(text);
    return e;
  }
  function readShow() {
    try { return window.sessionStorage.getItem(STORE_KEY) === '1'; } catch (e) { return false; }
  }
  function writeShow(v) {
    try { window.sessionStorage.setItem(STORE_KEY, v ? '1' : '0'); } catch (e) { /* storage blocked: the choice lasts for this render only */ }
  }
  const W = () => (words = words || window.DiagMapLayout.makeWords(TEXT));
  const glyphFor = n => (n.type === 'step' ? W().stepMark(n) : (n.state === 'not_traversed' ? '' : GLYPH[n.tone] || ''));
  const pct = c => W().pct(c);

  function hostWidth(host) {
    const cs = window.getComputedStyle(host);
    return Math.max(0, host.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0));
  }

  function ensureObserver() {
    if (observer || typeof window.ResizeObserver !== 'function') return;
    observer = new window.ResizeObserver(entries => entries.forEach(entry => {
      const host = entry.target, st = hosts.get(host);
      if (!host.isConnected || !st) { observer.unobserve(host); hosts.delete(host); return; }
      if (st.options.width !== undefined || st.data === undefined) return;
      if (Math.abs(hostWidth(host) - st.width) < 1) { drawEdges(st); return; }
      if (st.frame) return;
      st.frame = window.requestAnimationFrame(() => { st.frame = 0; paint(host, st); });
    }));
  }

  // ---------- tooltip ----------
  function showTip(st, anchor, lines) {
    const tip = st.tip;
    tip.replaceChildren(...lines.map((t, i) => el('div', i === 0 ? 'dm-tip-head' : null, t)));
    tip.hidden = false;
    const root = st.root.getBoundingClientRect(), r = anchor.getBoundingClientRect();
    const w = tip.offsetWidth, h = tip.offsetHeight;
    const left = Math.max(0, Math.min(r.left - root.left, root.width - w));
    const below = r.bottom - root.top + TIP_GAP_PX;
    const top = below + h > root.height && r.top - root.top - h - TIP_GAP_PX >= 0 ? r.top - root.top - h - TIP_GAP_PX : below;
    tip.style.left = left + 'px';
    tip.style.top = top + 'px';
    if (anchor.classList.contains('dm-item')) anchor.setAttribute('aria-describedby', tip.id);
  }
  function hideTip(st, anchor) {
    st.tip.hidden = true;
    if (anchor) anchor.removeAttribute('aria-describedby');
  }

  // ---------- items and cards ----------
  function item(st, n, cls, clamp) {
    const it = el('div', 'dm-item ' + cls + ' dm-t-' + n.tone);
    it.dataset.id = n.id;
    it.dataset.state = n.state;
    it.setAttribute('role', 'button');
    it.setAttribute('tabindex', '-1');
    it.setAttribute('aria-pressed', 'false');
    it.setAttribute('aria-label', W().accName(n));
    const g = glyphFor(n);
    if (g) it.append(el('span', 'dm-glyph', g));
    const t = el('span', 'dm-text dm-clamp-' + clamp, n.label);
    it.append(t);
    // a cause node whose write-up popover (rhs4 causeHover) opens on hover shows no second, older tooltip
    it.addEventListener('mouseenter', () => { if (!it.dataset.noTip) showTip(st, it, W().tipLines(st.data, st.model.byId, n)); });
    it.addEventListener('mouseleave', () => { if (document.activeElement !== it) hideTip(st, it); });
    it.addEventListener('focus', () => { st.focusId = n.id; if (!it.dataset.noTip) showTip(st, it, W().tipLines(st.data, st.model.byId, n)); });
    it.addEventListener('blur', () => hideTip(st, it));
    it.addEventListener('click', () => { focusItem(st, it); select(st, n.id); });
    st.items.set(n.id, it);
    return it;
  }

  function tag(text, cls) { return el('span', 'dm-tag ' + cls, text); }

  function stepRow(st, s, compact) {
    const current = s.state === 'current_step';
    const row = item(st, s, 'dm-step', compact && !current ? 2 : 3);
    if (s.finding && (s.state === 'ruled_out' || W().stepStatus(s) === 'done')) {
      row.append(el('span', 'dm-outcome', s.finding + (s.via === 'text' ? ' (' + TEXT.readFromMessage + ')' : '')));
    }
    return row;
  }

  // continue the diagnosis on this cause even if it was ruled out (the chat decides what that does; the map only reports the click)
  function overrideButton(st, n) {
    const b = el('button', 'dm-override', TEXT.override);
    b.type = 'button'; b.dataset.pid = n.id;      // shown and lit only while its cause is the selected one (applySelection)
    b.title = TEXT.overrideTip;
    b.setAttribute('aria-label', TEXT.override + ': ' + n.label);
    b.addEventListener('click', ev => { ev.stopPropagation(); st.options.onOverride(n.id); });
    return b;
  }

  function causeCard(st, card) {
    const n = card.head, box = el('div', 'dm-card dm-t-' + n.tone);
    const head = item(st, n, 'dm-chead', 3);
    const meta = el('div', 'dm-meta');
    if (n.tone === 'now') meta.append(tag(TEXT.nowTag, 'dm-tag-now'));
    if (n.state === 'ruled_out') meta.append(tag(TEXT.ruledTag, 'dm-tag-red'));
    else if (typeof n.confidence === 'number') meta.append(el('span', null, TEXT.confidence(pct(n.confidence))));
    head.append(meta);
    box.append(head);
    if (typeof st.options.onOverride === 'function' && n.state !== 'leading' && st.options.overridePid !== n.id) box.append(overrideButton(st, n));
    // rhs4 turns the cause node itself into the trigger of its write-up (hover shows, click pins); it returns the popover's holder
    const about = typeof st.options.causeHover === 'function' ? st.options.causeHover(head, n.id, n.label) : null;
    if (about) { head.dataset.noTip = '1'; box.append(about); }
    const failed = st.data.nodes.some(s => s.type === 'step' && s.parent === n.id && s.state === 'ruled_out') ||
      st.data.edges.some(e => e.kind === 'rules_out' && e.to === n.id);
    const reason = n.reason || (failed ? null : TEXT.ruledEarlier);
    if (n.state === 'ruled_out' && reason) box.append(el('div', 'dm-outcome', reason));
    if (card.steps && card.steps.length && st.model.fold.checks) {
      const list = el('div', 'dm-steps');
      card.steps.forEach(s => list.append(stepRow(st, s, true)));
      box.append(list);
    }
    if (card.root) {
      const r = card.root;
      const line = TEXT.rootCause + r.label + (r.fix ? ' · ' + (TEXT.fix[r.fix_kind] || TEXT.fixDefault) + r.fix : '');
      box.append(item(st, Object.assign({}, r, {label: line}), 'dm-rc', 2));
    }
    return box;
  }

  function card(st, c) {
    if (c.kind === 'cause') return causeCard(st, c);
    const tone = c.head ? c.head.tone : 'plain';
    const box = el('div', 'dm-card dm-t-' + tone + (c.indent ? ' dm-indent-' + c.indent : ''));
    if (c.head) box.dataset.state = c.head.state;
    if (c.indent) box.append(el('div', 'dm-fu', TEXT.followUp));
    if (c.kind === 'symptom') box.append(item(st, c.head, 'dm-chip dm-sym', 3));
    if (c.kind === 'question') {
      const q = item(st, c.head, 'dm-qhead', 3);
      if (c.head.tone === 'now') { const meta = el('div', 'dm-meta'); meta.append(tag(TEXT.nowTag, 'dm-tag-now')); q.append(meta); }
      box.append(q);
    }
    if (c.kind === 'other') box.append(el('div', 'dm-fu', TEXT.otherChecks));
    c.chips.forEach(f => box.append(item(st, f, 'dm-chip', 2)));
    if (c.kind === 'checks') {
      const list = el('div', 'dm-steps');
      c.steps.forEach(s => list.append(stepRow(st, s, false)));
      box.append(list);
    }
    if (c.kind === 'root') {
      box.append(item(st, Object.assign({}, c.head, {label: TEXT.rootCause + c.head.label}), 'dm-rc', 3));
      if (c.head.fix) box.append(el('div', 'dm-fixline dm-clamp-3', (TEXT.fix[c.head.fix_kind] || TEXT.fixDefault) + c.head.fix));
    }
    return box;
  }

  function column(st, col) {
    const box = el('div', 'dm-col');
    box.dataset.col = col.key;
    const head = el('div', 'dm-col-head', TEXT.columns[col.base]);
    if (col.unreached) head.append(el('span', 'dm-col-count', TEXT.colUnreached(col.unreached)));
    box.append(head);
    col.shown.forEach(c => { const b = card(st, c); c.el = b; box.append(b); c.items.forEach(n => st.cardEl.set(n.id, b)); });
    const expanded = st.expanded.has(col.key);
    if (col.more.length || expanded) {
      const btn = el('button', 'dm-more', expanded ? TEXT.fewer : TEXT.more(col.more.length));
      btn.type = 'button';
      btn.setAttribute('aria-expanded', String(expanded));
      btn.addEventListener('click', () => {
        if (expanded) st.expanded.delete(col.key); else st.expanded.add(col.key);
        st.refocus = '.dm-more[data-col="' + col.key + '"]';
        paint(st.host, st);
      });
      btn.dataset.col = col.key;
      st.moreEl.set(col.key, btn);
      box.append(btn);
    }
    if (col.base === window.DiagMapLayout.COL.CAUSES) {
      const over = (st.data.stats && st.data.stats.ruled_out_overflow) || [];
      if (over.length) box.append(el('p', 'dm-note', TEXT.overflow(over.length)));
    }
    return box;
  }

  // ---------- connectors ----------
  function anchor(st, id) {
    if (st.items.has(id)) return {item: st.items.get(id), box: st.cardEl.get(id) || st.items.get(id), col: st.model.columnOf.get(id)};
    const colKey = st.model.hiddenByMore.get(id);
    if (colKey && st.moreEl.has(colKey)) return {item: st.moreEl.get(colKey), box: st.moreEl.get(colKey), col: colKey, more: true};
    return null;
  }

  function drawEdges(st) {
    const svg = st.svg;
    if (!svg || !st.stage.isConnected) return;
    const base = st.stage.getBoundingClientRect();
    svg.setAttribute('width', String(base.width));
    svg.setAttribute('height', String(base.height));
    svg.setAttribute('viewBox', '0 0 ' + base.width + ' ' + base.height);
    svg.replaceChildren();
    const seen = new Set(), layers = [[], [], [], []];
    st.data.edges.forEach(e => {
      if (e.kind === 'answer') return;
      const a = anchor(st, e.from), b = anchor(st, e.to);
      if (!a || !b || a.col === b.col || (a.more && b.more)) return;
      const key = e.kind === 'tests' ? 'tests>' + e.from : (a.more ? a.col : e.from) + '>' + (b.more ? b.col : e.to);
      if (seen.has(key)) return;
      seen.add(key);
      const ar = a.box.getBoundingClientRect(), br = b.box.getBoundingClientRect();
      const ai = a.item.getBoundingClientRect(), bi = b.item.getBoundingClientRect();
      const rightward = ar.left < br.left;
      const x1 = (rightward ? ar.right : ar.left) - base.left, x2 = (rightward ? br.left : br.right) - base.left;
      const y1 = ai.top + ai.height / 2 - base.top, y2 = bi.top + bi.height / 2 - base.top;
      const dx = Math.max(CURVE_MIN_PX, Math.abs(x2 - x1) * CURVE_RATIO) * (rightward ? 1 : -1);
      const d = 'M' + x1 + ',' + y1 + ' C' + (x1 + dx) + ',' + y1 + ' ' + (x2 - dx) + ',' + y2 + ' ' + x2 + ',' + y2;
      const p = document.createElementNS(SVG_NS, 'path');
      const trail = e.tone === 'trail' && e.kind !== 'rules_out';
      p.setAttribute('class', 'dm-edge ' + (EDGE_CLASS[e.kind] || 'dm-e-supports') + (trail ? ' dm-e-trail' : ''));
      p.setAttribute('d', d);
      p.dataset.from = e.from;
      p.dataset.to = e.to;
      p.dataset.tone = e.tone || '';
      const layer = e.kind === 'rules_out' ? EDGE_LAYER.red : (EDGE_LAYER[e.tone] !== undefined ? EDGE_LAYER[e.tone] : 1);
      layers[layer].push(p);
      if (e.kind === 'rules_out') {
        const hit = document.createElementNS(SVG_NS, 'path');
        hit.setAttribute('class', 'dm-hit');
        hit.setAttribute('d', d);
        hit.setAttribute('stroke-width', String(HIT_WIDTH));
        const lines = [TEXT.ruledTag, e.why ? TEXT.ruledBy + e.why : ''].filter(Boolean);
        hit.addEventListener('mouseenter', () => showTip(st, a.item, lines));
        hit.addEventListener('mouseleave', () => hideTip(st, null));
        layers[EDGE_LAYER.red].push(hit);
      }
    });
    layers.forEach(l => l.forEach(p => svg.append(p)));
    applySelection(st);
  }

  // ---------- selection and keyboard ----------
  function applySelection(st) {
    const set = st.selected ? window.DiagMapLayout.pathFrom(st.data.edges, st.selected) : null;
    st.items.forEach((it, id) => {
      it.classList.toggle('dm-dim', !!set && !set.has(id));
      it.classList.toggle('dm-sel', st.selected === id);
      it.setAttribute('aria-pressed', String(st.selected === id));
    });
    st.root.querySelectorAll('.dm-override').forEach(btn => btn.classList.toggle('dm-override-lit', !!st.selected && btn.dataset.pid === st.selected));
    st.root.querySelectorAll('.dm-card').forEach(c => {
      const its = [...c.querySelectorAll('.dm-item')];
      c.classList.toggle('dm-dim', !!set && its.length > 0 && its.every(i => i.classList.contains('dm-dim')));
      its.forEach(i => { if (set && c.classList.contains('dm-dim')) i.classList.remove('dm-dim'); });
    });
    if (st.svg) {
      st.svg.querySelectorAll('.dm-edge').forEach(p => {
        p.classList.toggle('dm-dim', !!set && !(set.has(p.dataset.from) && set.has(p.dataset.to)));
      });
    }
  }

  function select(st, id) {
    st.selected = st.selected === id ? null : id;
    applySelection(st);
    if (typeof st.options.onSelect === 'function') st.options.onSelect(st.selected);
  }

  function focusItem(st, it) {
    if (!it) return;
    st.items.forEach(x => x.setAttribute('tabindex', '-1'));
    it.setAttribute('tabindex', '0');
    st.focusId = it.dataset.id;
    if (document.activeElement !== it) it.focus({preventScroll: false});
  }

  function onKey(st, ev) {
    const cur = ev.target.closest && ev.target.closest('.dm-item');
    if (ev.key === 'Escape') {
      hideTip(st, cur);
      if (st.selected) { select(st, st.selected); ev.preventDefault(); }
      return;
    }
    if (!cur) return;
    const cols = [...st.grid.querySelectorAll('.dm-col')].map(c => [...c.querySelectorAll('.dm-item')]).filter(c => c.length);
    const ci = cols.findIndex(c => c.includes(cur));
    if (ci < 0) return;
    const ii = cols[ci].indexOf(cur);
    const nearest = list => {
      const y = cur.getBoundingClientRect().top;
      return list.reduce((best, x) => (Math.abs(x.getBoundingClientRect().top - y) < Math.abs(best.getBoundingClientRect().top - y) ? x : best));
    };
    let next = null;
    if (ev.key === 'ArrowDown') next = cols[ci][ii + 1];
    else if (ev.key === 'ArrowUp') next = cols[ci][ii - 1];
    else if (ev.key === 'ArrowRight' && cols[ci + 1]) next = nearest(cols[ci + 1]);
    else if (ev.key === 'ArrowLeft' && cols[ci - 1]) next = nearest(cols[ci - 1]);
    else if (ev.key === 'Home') next = cols[ci][0];
    else if (ev.key === 'End') next = cols[ci][cols[ci].length - 1];
    else if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); select(st, cur.dataset.id); return; }
    else return;
    ev.preventDefault();
    if (next) focusItem(st, next);
  }

  // ---------- text alternative ----------
  function listView(st, open) {
    const d = el('details', 'dm-list');
    d.open = open;
    d.append(el('summary', null, TEXT.list));
    const ul = el('ul');
    W().listLines(st.data, st.model).forEach(t => ul.append(el('li', null, t)));
    d.append(ul);
    return d;
  }

  // ---------- paint ----------
  function toolbar(st) {
    const bar = el('div', 'dm-toolbar');
    bar.append(el('div', 'dm-title', TEXT.title));
    const hidden = st.model.unreachedTotal;
    const btn = el('button', 'dm-toggle', st.show ? TEXT.toggleHide : TEXT.toggleShow(hidden));
    btn.type = 'button';
    btn.setAttribute('aria-pressed', String(st.show));
    btn.setAttribute('aria-controls', st.gridId);
    btn.addEventListener('click', () => {
      st.show = !st.show;
      writeShow(st.show);
      st.refocus = '.dm-toggle';
      st.announce = st.show ? TEXT.liveShown(hidden) : TEXT.liveHidden(hidden);
      paint(st.host, st);
      if (typeof st.options.onToggle === 'function') st.options.onToggle(st.show);
      if (typeof st.options.onToggleUnreached === 'function') st.options.onToggleUnreached(st.show);
    });
    bar.append(btn);
    const legend = el('ul', 'dm-legend');
    legend.setAttribute('aria-label', TEXT.legendLabel);
    TEXT.legend.forEach(l => {
      const li = el('li', 'dm-l-' + l.tone);
      li.append(el('span', 'dm-swatch dm-t-' + l.tone, l.glyph), el('span', null, l.text));
      legend.append(li);
    });
    bar.append(legend);
    return bar;
  }

  function paint(host, st) {
    const L = window.DiagMapLayout;
    const hadFocus = st.root && st.root.contains(document.activeElement);
    const scrollLeft = st.scroller ? st.scroller.scrollLeft : 0;      // a repaint (resize, toggle, Show more) keeps the sideways position
    st.width = st.options.width !== undefined ? st.options.width : hostWidth(host);
    st.items = new Map();
    st.cardEl = new Map();
    st.moreEl = new Map();
    const root = el('div', 'dm-root');
    if (st.options.width !== undefined) root.style.width = st.options.width + 'px';
    st.root = root;
    st.tip = el('div', 'dm-tip');
    st.tip.id = st.gridId + '-tip';
    st.tip.setAttribute('role', 'tooltip');
    st.tip.hidden = true;
    const live = el('div', 'dm-live', st.announce || '');
    live.setAttribute('aria-live', 'polite');
    st.announce = '';
    if (!st.data || !(st.data.nodes || []).length) {
      root.append(el('p', 'dm-empty', TEXT.empty));
      host.replaceChildren(root);
      st.svg = null;
      st.scroller = null;
      return;
    }
    // every column is laid out (none folded into another) and the stage scrolls sideways when they do not fit; below the list-only
    // width the map stays a list as before
    const layoutWidth = st.width < L.LIST_ONLY_BELOW_PX ? st.width : Math.max(st.width, L.UNFOLDED_PX);
    st.model = L.build(st.data, {width: layoutWidth, showUnreached: st.show, expanded: st.expanded});
    root.append(toolbar(st), live);
    const stats = st.data.stats || {};
    if (stats.truncated) root.append(el('p', 'dm-note', TEXT.capped(stats.dropped || 0)));
    if (!st.model.listOnly) {
      const stage = el('div', 'dm-stage'), canvas = el('div', 'dm-canvas');
      const need = L.columnsWidth(st.model.columns.length);
      if (need > st.width) canvas.style.minWidth = need + 'px';      // it fits: the existing full-width look
      const svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('class', 'dm-svg');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const grid = el('div', 'dm-grid');
      grid.id = st.gridId;
      grid.setAttribute('role', 'group');
      grid.setAttribute('aria-label', TEXT.mapLabel);
      grid.style.gridTemplateColumns = 'repeat(' + st.model.columns.length + ', minmax(0, 1fr))';
      st.model.columns.forEach(col => grid.append(column(st, col)));
      grid.addEventListener('keydown', ev => onKey(st, ev));
      canvas.append(svg, grid);
      stage.append(canvas);
      root.append(stage);
      st.stage = canvas;      // the connectors are measured against the scrolled canvas, so they stay on their cards while scrolling
      st.scroller = stage;
      st.svg = svg;
      st.grid = grid;
    } else {
      st.svg = null;
      st.grid = null;
      st.scroller = null;
    }
    root.append(listView(st, st.model.listOnly), st.tip);
    root.addEventListener('keydown', ev => { if (ev.key === 'Escape' && !ev.target.closest('.dm-grid')) onKey(st, ev); });
    host.replaceChildren(root);
    const first = st.items.get(st.focusId) || st.items.values().next().value;
    if (first) first.setAttribute('tabindex', '0');
    if (st.scroller) st.scroller.scrollLeft = scrollLeft;
    if (st.svg) drawEdges(st);
    const back = st.refocus ? root.querySelector(st.refocus) : (hadFocus ? st.items.get(st.focusId) : null);
    st.refocus = null;
    if (back) back.focus({preventScroll: true});
  }

  function stateFor(host, options) {
    let st = hosts.get(host);
    if (!st) {
      st = {host, expanded: new Set(), selected: null, focusId: null, gridId: 'dm-map-' + (++uid), width: 0, frame: 0};
      hosts.set(host, st);
    }
    st.options = options || {};
    st.show = st.options.showUnreached !== undefined ? !!st.options.showUnreached : (st.show !== undefined ? st.show : readShow());
    return st;
  }

  // ---------- public API ----------
  function clean(raw) {
    if (!raw || typeof raw !== 'object') return raw;
    if (!cleaned.has(raw)) cleaned.set(raw, window.DiagMapLayout.cleanData(raw));
    return cleaned.get(raw);
  }

  function render(host, raw, options) {
    const st = stateFor(host, options), data = clean(raw);
    if (st.data !== data) {
      const ids = new Set(((data && data.nodes) || []).map(n => n.id));
      if (st.selected && !ids.has(st.selected)) st.selected = null;
    }
    st.data = data;
    liveHosts.add(host);
    ensureObserver();
    if (observer) observer.observe(host);
    paint(host, st);
  }

  function destroy(host) {
    if (!host) return;
    const st = hosts.get(host);
    if (st && st.frame) window.cancelAnimationFrame(st.frame);
    if (observer) observer.unobserve(host);
    hosts.delete(host);
    liveHosts.delete(host);
    host.replaceChildren();
  }

  // V5 (W7b): repaint every live map; called from the popover's ResizeObserver (FloatingPanel onResize), not window resize
  function relayout() {
    liveHosts.forEach(host => {
      const st = hosts.get(host);
      if (!st) { liveHosts.delete(host); return; }
      if (!host.isConnected || st.data === undefined || st.options.width !== undefined) return;
      if (st.frame) window.cancelAnimationFrame(st.frame);
      st.frame = window.requestAnimationFrame(() => { st.frame = 0; paint(host, st); });
    });
  }

  window.DiagMap = {render, destroy, relayout};
})();
